module.exports = require("node-emoji");


//////////////////
// WEBPACK FOOTER
// external "node-emoji"
// module id = 2
// module chunks = 0